module.exports = __webpack_public_path__ + "img/9.5df1810c.jpg";